// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-10-23T13:08:09Z                      #

// ##############################################################

export function updateSigningRequest_C85543(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.certificateInfo !== "undefined" && data.certificateInfo) {
        result.certificateInfo = updateCertificateInfo_0D10F4(data.certificateInfo);
    }

    return result;
}

export function updateMapSigningRequest_C85543(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSigningRequest_C85543(data[key]);
    });
    return result;
}

export function updateListSigningRequest_C85543(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSigningRequest_C85543);
}

export function updateCertificateInfo_0D10F4(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "HsmCertificateInfo":
            return data;
        case "McCertificateInfo":
            return data;
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapCertificateInfo_0D10F4(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateCertificateInfo_0D10F4(data[key]);
    });
    return result;
}

export function updateListCertificateInfo_0D10F4(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateCertificateInfo_0D10F4);
}
